// extracted by mini-css-extract-plugin
export default {"signatureField":"j5NlXf","header":"YwjjpQ","inputContainer":"my_VPD"};